var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.72,
    height: 57.249,
    viewBox: "0 0 63.72 57.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tienda",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_84",
    "data-name": "Grupo 84",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_219",
    "data-name": "Trazado 219",
    d: "M63.585,43.724,57.6,31.923v-4.68A1.245,1.245,0,0,0,56.352,26H7.367a1.245,1.245,0,0,0-1.245,1.245v4.681L.135,43.724A1.245,1.245,0,0,0,0,44.287v3.062a7.378,7.378,0,0,0,6.123,7.26V80.757H4.849a1.245,1.245,0,1,0,0,2.489H58.87a1.245,1.245,0,1,0,0-2.489H57.6V54.609a7.378,7.378,0,0,0,6.123-7.26V44.287A1.244,1.244,0,0,0,63.585,43.724ZM8.612,28.487h46.5v2.489H8.612ZM39.221,44.161l-1.085-10.7h7.5l3.351,11.007v2.876a4.879,4.879,0,0,1-9.757,0V44.287A1.249,1.249,0,0,0,39.221,44.161Zm-2.483.189v3h0a4.878,4.878,0,0,1-9.757,0v-3l1.1-10.884h7.548ZM25.584,33.466,24.5,44.161a1.208,1.208,0,0,0-.006.126v3.062a4.878,4.878,0,0,1-9.757,0V44.472l3.351-11.007ZM2.489,47.349V44.585L8.132,33.466h7.353L12.3,43.924a1.247,1.247,0,0,0-.054.363v3.062a4.879,4.879,0,0,1-9.757,0ZM50.13,80.758H42.662V72.046h1.245a1.245,1.245,0,1,0,0-2.489H42.662V60.845H50.13Zm4.978,0H52.618V59.6a1.245,1.245,0,0,0-1.245-1.245H12.346A1.245,1.245,0,0,0,11.1,59.6V77.024a1.244,1.244,0,0,0,1.245,1.245H40.173v2.489H8.612V54.609a7.381,7.381,0,0,0,4.879-3.168,7.361,7.361,0,0,0,12.246,0,7.361,7.361,0,0,0,12.246,0,7.362,7.362,0,0,0,12.246,0,7.38,7.38,0,0,0,4.879,3.168ZM25.728,60.845h4.336L27.7,63.211a1.245,1.245,0,1,0,1.76,1.76l4.127-4.126h6.589V75.779H13.59v-2.8ZM13.59,69.463V60.845h8.618ZM61.231,47.349a4.879,4.879,0,0,1-9.757,0V44.287a1.242,1.242,0,0,0-.054-.363L48.235,33.466h7.353l5.642,11.119Z",
    transform: "translate(0 -25.998)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    d: "M200.388,344.91a1.241,1.241,0,0,0,.878-.362l.021-.021a1.245,1.245,0,1,0-1.755-1.765l-.021.021a1.244,1.244,0,0,0,.877,2.127Z",
    transform: "translate(-174.359 -303.023)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_221",
    "data-name": "Trazado 221",
    d: "M1.274,466H1.245a1.245,1.245,0,0,0,0,2.489h.029a1.245,1.245,0,0,0,0-2.489Z",
    transform: "translate(0 -411.237)",
    fill: "#e51b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_222",
    "data-name": "Trazado 222",
    d: "M493.036,466h-.029a1.245,1.245,0,0,0,0,2.489h.029a1.245,1.245,0,1,0,0-2.489Z",
    transform: "translate(-430.561 -411.24)",
    fill: "#e51b26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerce);
export default __webpack_public_path__ + "static/media/commerce.c4e2c2bcc1e9d670e7a9062cf3b5de58.svg";
export { ForwardRef as ReactComponent };